module.exports = __webpack_public_path__ + "img/no-data-illustration.0e9fdc74.png";